<template>
  <v-dialog
    v-model="isOn"
    max-width="500px"
    persistent
  >
      <v-card>
        <v-card-title>
          <span class="headline capitalized">Remind</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap column>
              <v-flex xs12 sm6 md4>
                {{`Are you sure you want to remind?`}}
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="info"
            @click="close"
            >
              Cancel
            </v-btn>
          <v-btn
            :color="chooseActionButtonColor(actionName)"
            @click="action"
            :disabled="disabled"
          >
            remind
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
  export default {
    name: 'ModalForActions',
    props: {
      isOn: {
        required: true,
        type: Boolean,
        default: false
      },
      actionName: {
        required: true,
        type: String
      },
      disabled: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      close () {
        this.$emit('closeModal') //this.$emit('closeModal', 1)
      },
      action () {
        // this.$emit('deleteBlitz')
        this.$emit('submitAction')
      },
      chooseActionButtonColor (str) {
        return str === 'delete'
        ? 'error'
        : 'success'
      }
    }
  }
</script>

<style lang="scss" scoped>
  .capitalized {
    text-transform: capitalize;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/Registration/Invoices/changeStatusModal.vue